<template>
  <div class="login-page">
    <v-img
      class="login-bg"
      contain
      :src="require('../assets/login-bg.png')"
    ></v-img>
    <div v-if="isLoading" class="loader-frame">
      <div class="loader-outer">
        <div class="loader-inner"></div>
      </div>
    </div>

    <!--  FORGOT PASSWORD PAGE  -->
    <div v-if="$route.query.page == 'forgot-password'" class="forgot_frame">
      <v-img
        max-width="335"
        class="mb-12"
        :src="require('../assets/large-logo.png')"
      ></v-img>

      <div class="text-center font-16 text--black mb-3">
        ระบุอีเมลที่ทำการลงทะเบียนไว้ <br />
        เพื่อส่ง Link สำหรับสร้างรหัสผ่านใหม่
      </div>
      <v-form
        ref="validForgot"
        v-model="validForgot"
        lazy-validation
        class="mt-6"
        @submit="forgotPassword"
      >
        <v-text-field
          v-model="form_forgot.email"
          outlined
          height="40"
          background-color="#fff"
          color="#F7941D"
          style="border-radius: 30px"
          type="email"
          placeholder="อีเมล"
          :rules="[
            (v) => !!v || 'กรุณาระบุอีเมล',
            (v) => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง',
          ]"
          required
          @keyup.enter="forgotPassword"
        ></v-text-field>
      </v-form>

      <v-btn
        block
        dark
        rounded
        depressed
        class="btn_gradient"
        :loading="btnLoading"
        @click="forgotPassword"
      >
        <span class="font-14 font-w-700 font-ch">ส่งอีเมล</span>
      </v-btn>

      <div class="mt-5 txt-normal text-end">
        <a href="/">
          <span style="color: #000"> ย้อนกลับ </span>
        </a>
      </div>
    </div>

    <!--  RESET PASSWORD PAGE  -->
    <div v-else-if="$route.query.page == 'reset-password'" class="forgot_frame">
      <v-img
        max-width="335"
        class="mb-12"
        :src="require('../assets/large-logo.png')"
      ></v-img>

      <div class="text-center font-16 text--black mb-3">
        โปรดระบุรหัสผ่านใหม่เเละยืนยันรหัสผ่านใหม่
      </div>
      <v-form
        ref="validReset"
        v-model="validReset"
        lazy-validation
        class="mt-6"
      >
        <v-text-field
          v-model="form_reset.password"
          outlined
          height="40"
          background-color="#F5F5F5"
          color="#F7941D"
          style="border-radius: 30px"
          placeholder="รหัสผ่านใหม่"
          :type="show_password ? 'text' : 'password'"
          :rules="[
            (v) => !!v || 'กรุณาระบุรหัสผ่าน',
            (v) => v.length >= 6 || 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
          ]"
          required
        >
          <template v-slot:append>
            <v-icon
              :color="show_password ? '#F7941D' : '#b1b1b1'"
              @click="show_password = !show_password"
            >
              {{ show_password ? "mdi-eye" : "mdi-eye-off" }}
            </v-icon>
          </template>
        </v-text-field>

        <v-text-field
          v-model="form_reset.password_confirmation"
          outlined
          height="40"
          background-color="#F5F5F5"
          color="#F7941D"
          style="border-radius: 30px"
          placeholder="ยืนยันรหัสผ่านใหม่"
          :type="show_password_confirm ? 'text' : 'password'"
          :rules="[
            (v) => !!v || 'กรุณาระบุรหัสผ่าน',
            (v) => v.length >= 6 || 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
            (v) => v == form_reset.password || 'รหัสผ่านไม่ตรงกัน',
          ]"
          required
        >
          <template v-slot:append>
            <v-icon
              :color="show_password_confirm ? '#F7941D' : '#b1b1b1'"
              @click="show_password_confirm = !show_password_confirm"
            >
              {{ show_password_confirm ? "mdi-eye" : "mdi-eye-off" }}
            </v-icon>
          </template>
        </v-text-field>
      </v-form>

      <v-btn
        block
        dark
        rounded
        depressed
        class="btn_gradient"
        :loading="btnLoading"
        @click="resetPassword"
      >
        <span class="font-14 font-w-700 font-ch">บันทึกเพื่อเข้าสู่ระบบ</span>
      </v-btn>

      <div class="mt-5 txt-normal text-end">
        <a href="/">
          <span style="color: #000"> ย้อนกลับ </span>
        </a>
      </div>
    </div>

    <!--  REGISTER PAGE  -->
    <div v-else-if="$route.query.page == 'register'" class="register-frame">
      <div class="d-flex justify-center">
        <v-img
          max-width="250"
          class="mb-12"
          :src="require('../assets/large-logo.png')"
        ></v-img>
      </div>

      <div class="d-flex gap-12">
        <divcard style="min-width: calc(50% - 6px)" class="py-8 px-12">
          <div class="d-flex flex-column gap-12">
            <div class="flex">
              <div class="mb-1 black--text">
                คำนำหน้า
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <AutoBox
                theme="3"
                height="40"
                hide-details
                :items="masterData.title_list"
                item-text="name"
                item-value="name"
                :value="register_form.title"
                @onChange="setFormField('title', $event)"
              ></AutoBox>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อ
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                height="40"
                hide-details
                :value="register_form.firstname"
                @onChange="setFormField('firstname', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                สกุล
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                height="40"
                hide-details
                :value="register_form.lastname"
                @onChange="setFormField('lastname', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                ตำแหน่ง
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                height="40"
                hide-details
                :value="register_form.position"
                @onChange="setFormField('position', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                หน่วยงาน
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <AutoBox
                theme="3"
                height="40"
                hide-details
                :items="masterData.university_list"
                item-text="name_th"
                item-value="id"
                :value="register_form.university_id"
                @onChange="setFormField('university_id', $event)"
              ></AutoBox>
            </div>
          </div>
        </divcard>

        <divcard style="min-width: calc(50% - 6px)" class="py-8 px-12">
          <div class="d-flex flex-column gap-12 card-part">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์
                <!--                <span class="theme-color-seven txt-normal">*</span>-->
              </div>
              <TextField
                placeholder="02XXXXXXX"
                theme="3"
                height="40"
                hide-details
                :value="register_form.phone"
                @onChange="setFormField('phone', $event)"
              ></TextField>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์มือถือ
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                placeholder="09XXXXXXXX"
                theme="3"
                height="40"
                hide-details
                type="number"
                :value="register_form.mobile_phone"
                @onChange="setFormField('mobile_phone', $event)"
              ></TextField>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                E-mail
                <span class="theme-color-seven txt-normal">*</span>
              </div>
              <TextField
                theme="3"
                height="40"
                hide-details
                :value="register_form.email"
                @onChange="setFormField('email', $event)"
              ></TextField>
            </div>
          </div>

          <div class="pt-6">
            <div class="mb-1 black--text">
              สร้างรหัสผ่าน
              <span class="theme-color-seven txt-normal">*</span>
            </div>
            <TextField
              theme="3"
              height="40"
              hide-details
              :type="fieldTypePassword"
              :value="register_form.password"
              @onFocusIn="handleType"
              @onChange="setFormField('password', $event)"
            ></TextField>
            <div class="text-end txt-normal theme-color-one mt-2">
              รหัสผ่าน 6 ตัวอักษรขึ้นไป
            </div>
          </div>
        </divcard>
      </div>

      <div class="d-flex justify-space-between align-center gap-12 mt-5">
        <div class="txt-normal text-center">
          <a
            href="/"
            class="theme-color-seven txt-bigger font-weight-light text-decoration-underline"
            >เข้าสู่ระบบ</a
          >
        </div>

        <Button theme="1-1" width="250px" @onClick="pdpa">
          <div class="txt-bigger">สมัครสมาชิก</div>
        </Button>
      </div>
    </div>

    <!--  LOGIN PAGE  -->
    <!-- v-if="
        !$route.query.page ||
        $route.query.page !== 'register'
      " -->
    <div v-else class="login-frame">
      <v-img
        max-width="335"
        class="mb-12"
        :src="require('../assets/Logo2.png')"
      ></v-img>

      <TextField
        placeholder="email"
        class="mb-3"
        theme="4"
        height="48px"
        hide-details
        :error="errorEmail"
        :value="login_form.email"
        @onChange="login_form.email = $event"
      ></TextField>
      <TextField
        placeholder="password"
        type="password"
        theme="4"
        height="48px"
        hide-details
        :value="login_form.password"
        @onChange="login_form.password = $event"
        @onEnter="login"
      ></TextField>

      <div class="d-flex justify-space-between mt-2 txt-mini">
        <div class="d-flex align-center">
          <CheckBox
            :input-value="rememberMe"
            @onChange="rememberMe = $event"
          ></CheckBox>
          จดจำรหัสผ่านของฉัน
        </div>
        <div class="pt-1 d-flex align-center" style="color: #000">
          <div class="mr-1">คลิกที่นี่ หากคุณ</div>
          <a href="?page=forgot-password">
            <span
              style="color: #000"
              class="theme-color-seven font-weight-light text-decoration-underline"
            >
              ลืมรหัสผ่าน?
            </span>
          </a>
        </div>
      </div>

      <Button theme="1-1" class="mt-7" width="100%" @onClick="login">
        <div class="txt-bigger">เข้าสู่ระบบ</div>
      </Button>

      <div class="mt-5 txt-normal text-center">
        <a
          href="?page=register"
          class="theme-color-seven txt-bigger font-weight-light text-decoration-underline"
          >สมัครสมาชิก</a
        >
      </div>
    </div>

    <!-- DEV ENVIRONMENT WARNING MODAL -->
    <!-- *** UNCOMMENT THE LINES BELOW FOR DEV/STAGING ENVIRONMENT *** -->
    
    <v-dialog
      v-model="showDevWarning"
      width="90%"
      max-width="600"
      persistent
      class="dev-warning-modal"
    >
      <v-card>
        <div class="d-flex justify-end pa-2">
          <v-btn
            icon
            small
            @click="closeDevWarning"
            class="close-icon"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4 pt-0 text-center">
          <v-icon color="warning" size="64" class="mb-3">mdi-alert-circle</v-icon>
          <div class="font-24 font-weight-bold mb-3 warning--text">
            เว็บไซต์สำหรับทดสอบ
          </div>
          <div class="font-16 mb-4">
            นี่คือเว็บไซต์สำหรับการพัฒนาและทดสอบระบบเท่านั้น<br>
            หากต้องการใช้งานจริง กรุณาเข้าสู่เว็บไซต์หลัก
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 justify-center">
          <Button theme="1-1" @onClick="goToMainWebsite">
            <div class="txt-bigger">ไปยังเว็บหลัก</div>
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>
   

    <!-- PDPA  -->
    <div class="text-center pdpa_frame">
      <v-dialog v-model="dialog" width="800">
        <v-card>
          <v-card-text class="pa-4 font-26">
            เงื่อนไขยินยอมเปิดเผยข้อมูลส่วนตัว
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="pt-4">
            <div>
              เรียนคุณ
              <span class="name">
                {{ register_form.firstname }} {{ register_form.lastname }}
              </span>
            </div>
            <p>
              หากท่านยินยอมให้สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์
              วิจัยและนวัตกรรม เก็บรวบรวม ใช้และ
              เปิดเผยข้อมูลส่วนบุคคลของท่านภายใต้ข้อกำหนดและเงื่อนไข
              ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ดังต่อไปนี้
            </p>
            <span
              class="theme-color-seven font-weight-light text-decoration-underline"
              style="cursor: pointer"
              @click="showPolicy = true"
            >
              (Click อ่านรายละเอียด)
            </span>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text
            v-if="showPolicy"
            class="pt-4 pdpa_desc"
            id="scrollContainer"
            ref="scrollContainer"
          >
            <div v-html="policy"></div>
          </v-card-text>

          <v-divider v-if="showPolicy"></v-divider>

          <v-card-text class="pt-4">
            <div>โปรดยืนยันดังต่อไปนี้</div>
            <p>
              ข้าพเจ้ารับทราบและยินยอมให้สำนักงานปลัดกระทรวงการอุดมศึกษา
              วิทยาศาสตร์ วิจัยและนวัตกรรม เก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลของข้าพเจ้าตามข้อกำหนดและเงื่อนไขที่กล่าวมาทั้งสิ้น
            </p>
          </v-card-text>

          <v-card-actions class="pb-6">
            <v-spacer></v-spacer>
            <v-btn
              width="115"
              height="40"
              dark
              rounded
              color="#464647"
              @click="onAgree(false)"
            >
              ไม่ยินยอม
            </v-btn>
            <v-btn
              width="115"
              height="40"
              class="btn_gradient"
              rounded
              @click="onAgree(true)"
            >
              ยินยอม
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import TextField from "../components/input/TextField";
import SelectBox from "@/components/input/SelectBox";
import AutoBox from "@/components/input/AutoBox";
import Button from "../components/input/Button";
import { getCookie__c } from "../plugins/cookies";
import { eventBus, validateEmail } from "../plugins/global-funcs";
import { mapState } from "vuex";
import CheckBox from "@/components/input/CheckBox";
import { policy } from "./policy.js";

export default {
  name: "Home",
  components: {
    TextField,
    Button,
    CheckBox,
    SelectBox,
    AutoBox,
  },
  data() {
    return {
      login_form: {
        email: "",
        password: "",
      },
      register_form: {},
      rememberMe: false,
      errorEmail: false,
      masterData: {},
      validForgot: true,
      btnLoading: false,
      form_forgot: {
        email: "",
      },
      validReset: true,
      form_reset: {
        token: "",
        password: "",
        password_confirmation: "",
      },
      show_password: false,
      show_password_confirm: false,
      dialog: false,
      showPolicy: false,
      policy,
      reachedBottom: false,
      agreedToPolicy: false,
      fieldTypePassword: "text",
      // *** UNCOMMENT THE LINE BELOW FOR DEV/STAGING ENVIRONMENT ***
      showDevWarning: true,
    };
  },
  computed: {
    ...mapState({
      userLogin: (state) => state.Auth.User,
      lastCreds: (state) => state.Auth.login.lastCredentials,
      isLoading: (state) => state.General.isLoading,
    }),
  },
  async created() {
    if (!!this.userLogin.email) {
      this.$router.push({ name: "Dashboard" });
    }

    // remember?
    if (this.lastCreds && this.lastCreds.length === 2) {
      this.rememberMe = true;
      this.login_form.email = atob(this.lastCreds[0]);
      this.login_form.password = atob(this.lastCreds[1]);
    }

    if (this.$route.query.page === "register") {
      let res = await this.$apiFire("Auth/getMasterRegister");
      this.masterData = res;
      console.log(res);
    }

    if (this.$route.query.page === "reset-password") {
      this.form_reset.token = this.$route.query.token;
    }
  },

  watch: {
    showPolicy: {
      handler: function (val) {
        if (val) {
          // if scroll to bottom finish then remove event listener
          this.$nextTick(() => {
            this.$refs.scrollContainer.addEventListener(
              "scroll",
              this.handleScroll
            );
          });
        }
      },
    },
  },

  methods: {
    handleScroll() {
      const container = this.$refs.scrollContainer;
      const isScrolledToBottom =
        container.scrollHeight - container.scrollTop === container.clientHeight;
      this.reachedBottom = isScrolledToBottom;

      if (isScrolledToBottom) {
        this.$refs.scrollContainer.removeEventListener(
          "scroll",
          this.handleScroll
        );
      }
    },
    agreeToPolicy() {
      this.agreedToPolicy = true;
    },

    async login() {
      if (!validateEmail(this.login_form.email)) {
        this.errorEmail = true;
        return;
      }
      this.errorEmail = false;
      let res = await this.$apiFire("Auth/login", this.login_form, true);
      if (res.message === "เข้าสู่ระบบสำเร็จ") {
        if (this.rememberMe) {
          let logins = [
            btoa(this.login_form.email),
            btoa(this.login_form.password),
          ];
          this.$store.commit("Auth/rememberMe", logins);
        } else {
          this.$store.commit("Auth/clearCredentials");
        }
        await this.$apiFire("Auth/getUser");
        this.$router.push({ name: "Dashboard" });
      }
    },
    async logout() {
      await this.$apiFire("Auth/logout");
      this.$store.commit("Auth/clearUserInfo");
    },

    async pdpa() {
      this.dialog = true;
    },

    async onAgree(val) {
      // set cookie 1 year expire date
      const name = "policy-" + this.register_form.email;
      this.$cookie.set(name, val, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      });

      this.dialog = false;
      this.showPolicy = false;
      this.reachedBottom = false;
      this.agreedToPolicy = false;
      if (val) {
        this.register();
      }
    },

    async register() {
      let payload = {
        ...this.register_form,
        password_confirmation: this.register_form.password,
      };

      this.reachedBottom = false;
      this.agreedToPolicy = false;

      console.log("payload: ", payload);
      try {
        let res = await this.$apiFire("Auth/register", payload, true);
        console.log(res);
        if (res && res.message === "สมัครสมาชิกสำเร็จ") {
          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: res.message,
            showCancel: false,
            action: () => this.$router.push("/"),
          });
        }
      } catch (error) {
        this.$store.commit('General/setModal', {
          title: 'Error',
          text: error.message,
          theme: "error",
          showCancel: false,
          buttonText: 'OK'
        })
        return
      }
    },

    setFormField(field, val) {
      this.register_form[field] = val;
      this.$forceUpdate();
    },

    async forgotPassword() {
      if (this.$refs.validForgot.validate()) {
        this.btnLoading = true;
        const res = await this.$apiFire(
          "Auth/forgotPassword",
          this.form_forgot
        );

        this.btnLoading = false;

        if (res) {
          console.log(res);
          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: "เราได้ทำการส่ง link สำหรับเปลี่ยนรหัสผ่านไปยังอีเมลของคุณแล้ว",
            showCancel: false,
            action: () => {
              this.$router.replace("/");
              // window.location.reload();
            },
          });
        }
      }
    },

    async resetPassword() {
      if (this.$refs.validReset.validate()) {
        this.btnLoading = true;
        const res = await this.$apiFire("Auth/resetPassword", this.form_reset);

        this.btnLoading = false;

        if (res) {
          console.log(res);
          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: "เราได้ทำการเปลี่ยนรหัสผ่านของคุณแล้ว",
            showCancel: false,
            action: () => {
              this.$router.replace("/");
            },
          });
        }
      }
    },
    handleType(ev) {
      console.log(ev);
      const { srcElement, type } = ev;
      const { value } = srcElement;

      // prevent from suggestion by chrome
      if (type === "blur" && !value) {
        this.fieldTypePassword = "text";
      } else {
        this.fieldTypePassword = "password";
      }
    },

    // *** UNCOMMENT THE METHODS BELOW FOR DEV/STAGING ENVIRONMENT ***
    
    closeDevWarning() {
      this.showDevWarning = false;
    },
    goToMainWebsite() {
      window.open('http://rsptoms.mhesi.go.th/', '_blank');
      this.showDevWarning = false;
    },
    
  },

  // beforeDestroy() {
  //   // this.$refs.scrollContainer.removeEventListener("scroll", this.handleScroll);
  // },
};
</script>

<style scoped lang="scss">
.login-page {
  position: relative;
  margin: -12px; /* remove container padding */
  min-height: 100vh;
  background: linear-gradient(180deg, #ffffff 49.48%, #fff5e7 100%);
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}
.login-frame,
.register-frame {
  position: relative;
  z-index: 5;
}
.register-frame {
  min-width: 50vw;
}
.login-bg {
  position: absolute;
  top: 5vh;
  left: 0;
  width: 100%;
  max-height: 90vh;
}

.forgot_frame {
  position: relative;
  .btn_gradient {
    height: 48px;
    background: linear-gradient(0deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    color: #fff !important;
  }
}
</style>

<style lang="scss">
.forgot_frame {
  .v-text-field .v-input__prepend-inner,
  .v-text-field .v-input__append-inner {
    margin-top: 8px !important;
  }
}
.btn_gradient {
  height: 48px;
  background: linear-gradient(0deg, #f15a29 6.18%, #fbb040 84.83%);
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  color: #fff !important;
}
.pdpa_desc {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
